<template>
  <div class="check-mark">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="11" fill="#00ABEC"/>
      <path d="M3 11.4L4.6 9.8L8.6 13.8L17.4 5L19 6.6L8.6 17L3 11.4Z" fill="white"/>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'CheckMark'
}
</script>

<style lang="scss" scoped>

</style>
